import React from "react";
import { StringWidget } from "./StringWidget";

export function ExpressionWidget(props) {
  const { config, doAction } = props;

  const actionButtonOptions =
  {
    icon: 'bulletlist',
    action: async (value, textElement) => {
      let selectionStart = textElement.selectionStart;
      let content = JSON.stringify({ Value: value, CaretPosition: selectionStart });
      await doAction(config.ActionId, content);
    }
  };

  return (
    <StringWidget
      isBaseWidgetFor="ExpressionWidget"
      actionButtonOptions={actionButtonOptions}
      {...props}
    />
  );
}